import { NgModule } from '@angular/core';
import { StaffComponent } from './staff.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from "../../shared/shared.module";
import { NgxCarouselModule } from 'ngx-carousel';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    BrowserModule,
    SharedModule,
    NgxCarouselModule
  ],
  declarations: [StaffComponent]
})
export class StaffModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/staff/staff.module.ts